import React from "react";
import Fade from "react-reveal/Fade";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/**
 * Interface pour les données d'un catalogue
 */
interface CatalogData {
  image: string;
  pdfPath: string;
  title: string;
  categoryTitle: string;
  /** Ligne supplémentaire sous le titre (ex: "Signatur'Afrika") */
  categoryTitleLine2?: string;
}

/**
 * Composant pour afficher une bannière de catalogue
 */
const CatalogBanner: React.FC<CatalogData> = ({
  image,
  pdfPath,
  title,
  categoryTitle,
  categoryTitleLine2,
}) => {
  const handleDownload = () => {
    // Créer un lien temporaire pour télécharger le PDF
    const link = document.createElement("a");
    link.href = pdfPath;
    link.download = pdfPath.split("/").pop() || "catalogue.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Col lg={6} md={6} sm={12} className="catalog-col">
      <Fade bottom>
        <div className="catalog-banner-container">
          <div className="catalog-banner-image-wrapper">
            <img
              src={image}
              alt={title}
              className="catalog-banner-image"
              loading="lazy"
            />
          </div>
          <h4 className="catalog-banner-category-title">
            {categoryTitle}
            {categoryTitleLine2 && (
              <>
                <br />
                <span className="catalog-banner-category-title-line2">
                  {categoryTitleLine2}
                </span>
              </>
            )}
          </h4>
          <button
            className="btn btn-catalog-download"
            onClick={handleDownload}
            aria-label={`Télécharger ${title}`}
          >
            TÉLÉCHARGER LE CATALOGUE
          </button>
        </div>
      </Fade>
    </Col>
  );
};

/**
 * Section des catalogues - Affiche les bannières de catalogues (grille 2x2)
 * Ordre respecté = ordre d'ajout des fichiers dans le dossier Google Drive
 * "Catalogues Yeksina HOME"
 */
const CatalogSection: React.FC = () => {
  const catalogs: CatalogData[] = [
    {
      image: "/images/Catalogue RABAL - Carrelage adhésif.jpg",
      pdfPath: "/PDFs1/Catalogue RABAL - Adhesifs.pdf",
      title: "Catalogue RABAL - Adhésifs",
      categoryTitle: "CARREAUX ADHÉSIFS",
      categoryTitleLine2: "Collection Rabal",
    },
        {
      image: "/images/Catalogue SIGNATUR' AFRIKA.jpg",
      pdfPath: "/PDFs3/Catalogue SIGNATUR AFRIKA - Adhesifs.pdf",
      title: "Catalogue SIGNATUR'AFRIKA - Adhésifs",
      categoryTitle: "CARREAUX ADHÉSIFS",
      categoryTitleLine2: "Édition Signatur'Afrika",
    },
    {
      image: "/images/Catalogue RABAL - Carrelage grès cérame.jpg",
      pdfPath: "/PDFs2/Catalogue RABAL - Gres cerame.pdf",
      title: "Catalogue RABAL - Grès cérame",
      categoryTitle: "CARREAUX GRÈS CÉRAME",
      categoryTitleLine2: "Collection Rabal",
    },

    {
      image: "/images/Catalogue SWAHILI - Grès cérame.jpg",
      pdfPath: "/PDFs4/Catalogue SWAHILI - Gres cerame.pdf",
      title: "Catalogue SWAHILI - Grès cérame",
      categoryTitle: "CARREAUX GRÈS CÉRAME",
      categoryTitleLine2: "Collection Swahili",
    },
  ];

  return (
    <section className="catalog-section my-5">
      <Row className="g-0">
        {catalogs.map((catalog, index) => (
          <CatalogBanner
            key={index}
            image={catalog.image}
            pdfPath={catalog.pdfPath}
            title={catalog.title}
            categoryTitle={catalog.categoryTitle}
            categoryTitleLine2={catalog.categoryTitleLine2}
          />
        ))}
      </Row>
    </section>
  );
};

export default CatalogSection;